jQuery(document).ready(function ($) {
  $('[data-fancybox="video-block"]').fancybox({
    iframe: {
      css: {
        width: '50%',
        height: '50%',
      },
    },
  });
});
